import * as ACT from '../actions/settingsActions';

export function settings(state = {}, action) {
    switch (action.type) {


        case ACT.SETTINGS_GET_ITEM:
            return {
                ...state,
                getItem: action.data,
            };
        case ACT.SETTINGS_SET_ITEM:
            return {
                ...state,
                targetItem: action.data,
            };


        case ACT.SETTINGS_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };
        case ACT.SETTINGS_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };


        default:
            return state
    }
};
